import { render, staticRenderFns } from "./RsaPazienteAccettazioneSettingLivelliPage.vue?vue&type=template&id=b713b7ee"
import script from "./RsaPazienteAccettazioneSettingLivelliPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAccettazioneSettingLivelliPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports